import apiService from 'src/enviroment'
import { loaderService } from 'src/services/loaderService'

const getRecipients= async() => {
  loaderService.show()
  try {
    const response = await apiService.get('/trakku/email_destinatario/')
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const updateEmailRecipient = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.post('/trakku/email_destinatario/', params)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
    }
  }

export { getRecipients, updateEmailRecipient }